import { mobile, signer, signerAccentBar } from "theme/colors";
import { authRef, refFont } from "screens/Auth/AuthReferenceStyles";

// Same card chrome as McpAuthorize, the other bridge page that sits between an
// external system and the app's own login.
const awsMarketplaceSetupStyles = {
  accentBar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "5px",
    background: signerAccentBar,
    zIndex: (theme: any) => theme.zIndex.appBar,
  },
  card: {
    width: "100%",
    maxWidth: 460,
    mx: "auto",
    borderRadius: "16px",
    border: `1px solid ${authRef.cardBorder}`,
    boxShadow: authRef.cardShadow,
    padding: { xs: "28px 24px 24px", sm: "40px 44px 36px" },
    boxSizing: "border-box",
  },
  cardContent: { p: 0, "&:last-child": { pb: 0 } },
  column: { display: "flex", flexDirection: "column", alignItems: "center" },
  logo: { width: 106, height: "auto", display: "block" },
  heading: {
    color: mobile.base[500],
    fontSize: refFont.cardHeading,
    fontWeight: 700,
    textAlign: "center",
    mt: 3,
  },
  body: {
    color: authRef.subText,
    fontSize: refFont.cardBody,
    lineHeight: 1.6,
    textAlign: "center",
    mt: 1,
  },
  meta: {
    mt: 2,
    fontSize: refFont.label,
    color: authRef.metaText,
    textAlign: "center",
  },
  progress: {
    width: "100%",
    mt: 3,
    height: 6,
    borderRadius: "999px",
    backgroundColor: authRef.inputBorder,
    "& .MuiLinearProgress-bar": {
      borderRadius: "999px",
      backgroundColor: signer.orange.main,
    },
  },
  actions: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    mt: 3,
  },
  link: {
    color: signer.orange.main,
    fontWeight: 600,
  },
} as const;

export default awsMarketplaceSetupStyles;
